'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (_ref) {
  var url = _ref.url,
      method = _ref.method,
      params = _ref.params,
      data = _ref.data,
      xhrConfig = _ref.xhrConfig,
      auth = _ref.auth,
      headers = _ref.headers;

  url = url.replace(/^\//, '');

  var headersConfig = auth ? _extends({
    auth_token: auth
  }, headers) : _extends({}, headers);

  /**
  This line will throw if the baseUrl is not configured on the server side.
  **/
  if ((0, _isomorphicHelpers.isServerSide)() && (!xhrConfig || !xhrConfig.baseUrl)) {
    throw new Error('No xhrConfig set up in the loader but is used server side or no BASE_URL set up in the loader.');
  }

  var BASE_URL = xhrConfig && xhrConfig.baseUrl || window.location.href.includes('localhost') && _constants.LOCAL_BASE_URL || '';

  return (xhrConfig && xhrConfig.xhrAdapter || _axios2.default)({
    url: BASE_URL + '/api/' + url,
    headers: headersConfig,
    method: method,
    params: params,
    data: data,
    paramsSerializer: function paramsSerializer(params) {
      if (!params) {
        return '';
      }
      var encodedParamsString = '';
      Object.keys(params).forEach(function (key) {
        return params[key] !== null && typeof params[key] !== 'undefined' && (encodedParamsString += '' + (encodedParamsString.length ? '&' : '') + encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
      });
      return encodedParamsString;
    }
  });
};

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _constants = require('./constants');

var _isomorphicHelpers = require('./isomorphic-helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-utils/lib/api.js
// module id = 404
// module chunks = 0